var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerificationBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 216,
    viewBox: "0 0 216 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1092_6990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.9368 7.31561C104.511 3.16534 111.489 3.16534 116.063 7.31561L133.921 23.5173C136.247 25.6282 139.309 26.7425 142.448 26.621L166.542 25.6883C172.714 25.4494 178.059 29.9346 178.895 36.0542L182.161 59.9439C182.586 63.0565 184.215 65.8781 186.698 67.8029L205.755 82.5756C210.636 86.3598 211.848 93.2315 208.555 98.4571L195.7 118.857C194.026 121.514 193.46 124.723 194.125 127.793L199.227 151.359C200.534 157.396 197.045 163.439 191.164 165.325L168.204 172.689C165.212 173.649 162.717 175.743 161.252 178.522L150.013 199.855C147.134 205.319 140.577 207.706 134.859 205.37L112.537 196.253C109.629 195.065 106.371 195.065 103.463 196.253L81.1409 205.37C75.4229 207.706 68.866 205.319 65.9869 199.855L54.7477 178.522C53.2834 175.743 50.7875 173.649 47.7961 172.689L24.8364 165.325C18.9549 163.439 15.4661 157.396 16.7731 151.359L21.8755 127.793C22.5402 124.723 21.9745 121.514 20.2997 118.857L7.44506 98.4571C4.15218 93.2315 5.36384 86.3598 10.2454 82.5756L29.3018 67.8028C31.7847 65.8781 33.4137 63.0565 33.8392 59.9439L37.1045 36.0542C37.941 29.9346 43.2862 25.4494 49.4581 25.6883L73.5519 26.621C76.6911 26.7425 79.7527 25.6282 82.0793 23.5173L99.9368 7.31561Z",
    fill: "#374DA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.62 73.5703L99.8801 120.69L78.75 99.5754L69 109.325L101.495 141.82L147 83.3203L135.62 73.5703Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1092_6990",
    x: -4,
    y: -3,
    width: 224,
    height: 224,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1092_6990"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1092_6990"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1092_6990",
    result: "effect2_dropShadow_1092_6990"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1092_6990",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationBadge);
export default __webpack_public_path__ + "static/media/VerificationBadge.e6e5512cce59cf532a3c16214af24873.svg";
export { ForwardRef as ReactComponent };